import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api';

export interface Session {
  id: string;
  ip_address: string | null;
  created_at: string;
  expires_at: string;
  is_current: boolean;
}

export function useSessions() {
  return useQuery({
    queryKey: ['sessions'],
    queryFn: async () => (await api.get<Session[]>('/auth/sessions')).data,
  });
}

export function useRevokeSession() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => { await api.delete(`/auth/sessions/${id}`); },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['sessions'] }),
  });
}
